import type { Session } from '@supabase/supabase-js'
import { apiRegistry } from '../backendApi/apiRegistry'
import { authClient } from '../backendApi/authClient'
import type { Article } from '../drizzle/schemaType'
import { command } from 'ccstate'

export const setupFakeBackend = command(({get}) => {
  if (process.env.VITE_USE_FAKE_BACKEND !== 'true') {
    return
  }
  authClient.useFake = {
    access_token: 'fake_access_token',
    user: {
      email: 'prototype@user.com'
    }
  } as Session
  apiRegistry.useDirectRoute = get
  apiRegistry.registerGetApi('getAllArticles', async () => {
    const article: Article = {
      id: 1,
      title: 'fake title',
      slug: 'fake slug',
      content: 'This is a randomly generated article content.',
      excerpt: 'A brief excerpt of the article.',
      author: 'author',
      status: 'draft',
      tags: 'random,generated',
      featured: false,
      view_count: 0,
      created_at: '',
      published_at: '',
      updated_at: ''
    }
    return {
      data: [article]
    }
  })
  apiRegistry.registerPostApi('createRandomArticle', async () => {
    return { articleId: 0 }
  })
})